import React from "react";
import { AccentAlignments } from ".";
import { ComponentProps, MarginPaddingSizes, Vector } from "../../../types";
import DivWrapper from "../../containers/DivWrapper";
import * as styles from "./Accent.module.css";

interface Props extends ComponentProps {
  vector: Vector;
  alignment: AccentAlignments;
  margin?: {
    top: MarginPaddingSizes;
    bottom: MarginPaddingSizes;
    left: MarginPaddingSizes;
    right: MarginPaddingSizes;
  };
  padding?: {
    top: MarginPaddingSizes;
    bottom: MarginPaddingSizes;
    left: MarginPaddingSizes;
    right: MarginPaddingSizes;
  };
  height: MarginPaddingSizes;
}

export const Accent: React.FC<Props> = ({
  vector,
  margin,
  padding,
  alignment,
  height,
  ...props
}) => {
  let classes = `${styles.accent} `;
  if (margin?.top) {
    classes += `margin-top--${margin.top} `;
  }

  if (margin?.bottom) {
    classes += `margin-bottom--${margin.bottom} `;
  }

  if (margin?.left) {
    classes += `margin-left--${margin.left} `;
  }

  if (margin?.right) {
    classes += `margin-right--${margin.right} `;
  }

  if (padding?.top) {
    classes += `padding-top--${padding.top} `;
  }

  if (padding?.bottom) {
    classes += `padding-bottom--${padding.bottom} `;
  }

  if (padding?.left) {
    classes += `padding-left--${padding.left} `;
  }

  if (padding?.right) {
    classes += `padding-right--${padding.right} `;
  }

  if (alignment) {
    classes += `${styles[`${alignment}`]} `;
  }

  if (height && height !== "default") {
    classes += styles[`${height}`];
  }

  return (
    <DivWrapper {...props}>
      <div className={classes} data-kontent-element-codename="vector">
        <img src={vector.item.url} alt={vector.alt} />
      </div>
    </DivWrapper>
  );
};
